








import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";
import ReportImageUpload from "./ReportImageUpload.vue";

@Component({
  components: {
    LayoutReportStep,
    ReportImageUpload
  }
})
export default class ReportImageTire extends ReportStepMixin implements IReportStep {
  asset = AssetEnum.tireExampleOutlined;
  example = AssetEnum.tireExample;

  screen = ReportScreenEnum.tireimage;

  header: IReportHeaderData = {
    title: "report.imageTire.title",
    description: "report.imageTire.description",
    debug: this.files,
    image: AssetEnum.tireExampleAlt
  };

  instruction: IReportInstructionData = {
    title: "",
    text: "",
    pictures: [AssetEnum.tire],
    example: AssetEnum.tire,
    display: false
  };

  get isDone() {
    return this.files.length > 0;
  }

  get type() {
    return ReportImageType.tire;
  }

  get files(): IImageUploaded[] {
    return ReportModule.overviews.filter(image => image.type === this.type);
  }
}
